import { action, observable, runInAction, configure } from "mobx";
import { PostProcessingApi } from "apis";
import ApiStore from "./ApiStore";
import BaseStore from "./BaseStore";

configure({ enforceActions: "observed" });

class PostProcessingStore extends BaseStore {
  @observable postProcesses = [];
  @observable keepFilterState = false;
  @observable editProcess = {};

  constructor(props) {
    super(props);
    this.api = new PostProcessingApi();
  }

  async getPostProcesses() {
    const { size, page, sortDir, sortKey } = this.paging;
    let payload = { size, page, sortDir, sortKey };
    let response = await ApiStore.call(this.api, this.api.getAll, payload);
    if (response) {
      runInAction(() => {
        this.updatePagingFiler(response.paging);
        this.postProcesses = response.elements;
        if (this.paging?.totalRecord && this.paging?.totalRecord !== 0) {
          if (this.paging?.page > 1 && (!response.elements || response.elements.length === 0)) {
            this.updatePagingFiler({ page: this.paging.page - 1 });
            this.getPostProcesses();
          }
        }
      })
    }
  }

  @action
  async getPostProcessById(id, cb = null) {
    let response = await ApiStore.call(this.api, this.api.getById, id);
    if (response) {
      runInAction(() => {
        response.setting_body = JSON.parse(response.setting_body);
        if (response.setting_body.length <= 0) {
          response.setting_body.push({ regex: "", replacement: "" });
        }
        this.editProcess = JSON.parse(JSON.stringify(response));
        cb && cb();
      })
    }
  }

  @action
  async createPostProcess(payload, cb = null) {
    let response = await ApiStore.call(this.api, this.api.createPostJob, payload);
    if (response) {
      runInAction(() => {
        cb && cb(response?.id);
      })
    }
    return response;
  }

  @action
  async updatePostProcess(id, payload, cb = null) {
    let response = await ApiStore.call(this.api, this.api.updatePostJob, [id, payload]);
    if (response) {
      runInAction(() => {
        response.setting_body = JSON.parse(response.setting_body);
        this.editProcess = JSON.parse(JSON.stringify(response));
        cb && cb();
      })
    }
    return response;
  }

  @action
  async deletePostProcess(id) {
    let resp = await ApiStore.call(this.api, this.api.deletePostJob, id);
    if (resp) {
      runInAction(() => {
        this.getPostProcesses();
      })
    }
  }

  @action
  updateRow(index, field, value) {
    if (this.editProcess.setting_body && this.editProcess.setting_body[index]) {
      this.editProcess.setting_body[index][field] = value;
    }
  }

  @action
  addRow(index) {
    if (this.editProcess.setting_body) {
      this.editProcess.setting_body.splice(index, 0, { pattern: "", replacement: "" });
      this.editProcess = JSON.parse(JSON.stringify(this.editProcess));
    }
  }

  @action
  addRowAtEnd() {
    if (this.editProcess.setting_body) {
      this.editProcess.setting_body.push({ pattern: "", replacement: "" });
      this.editProcess = JSON.parse(JSON.stringify(this.editProcess));
    }
  }

  @action
  deleteRow(index) {
    if (this.editProcess.setting_body && this.editProcess.setting_body.length > index) {
      this.editProcess.setting_body.splice(index, 1);
      this.editProcess = JSON.parse(JSON.stringify(this.editProcess));
    }
  }

  @action
  swapRows(index1, index2) {
    if (this.editProcess.setting_body &&
      index1 >= 0 && index1 < this.editProcess.setting_body.length &&
      index2 >= 0 && index2 < this.editProcess.setting_body.length) {
      const temp = this.editProcess.setting_body[index1];
      this.editProcess.setting_body[index1] = this.editProcess.setting_body[index2];
      this.editProcess.setting_body[index2] = temp;
      this.editProcess = JSON.parse(JSON.stringify(this.editProcess));
    }
  }

  @action
  clean() {
    if (!this.keepFilterState) {
      console.log("PostProcessingStore -> clean -> this.keepFilterState", this.keepFilterState)
      super.clean();
    }
  }
}

export default PostProcessingStore;